export const ENV = import.meta.env.VITE_APP_ENV || 'dev3';

export const ROLLBAR_TOKEN = 'b9e3ed831f9042da805f9d109ff981e5';
